/* ==================================================================
   VYLOIRE.JS — single deferred behavior layer for Vyloire Premium.
   Consolidates the inline scripts formerly in: vyloire-experience
   (button pulse), vyloire-clean-title (PDP title trim),
   vyloire-pdp-motion (reveal), vyloire-pdp-studio (sticky buy bar +
   configurator, cinematic mobile gallery). Every module self-guards,
   so this file is safe on every page type.
   ================================================================== */

/* — Module 1: button press pulse — */
(function () {
  document.addEventListener('click', function (e) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var b = e.target.closest ? e.target.closest('.button') : null;
    if (b) { b.classList.remove('v-pulse'); void b.offsetWidth; b.classList.add('v-pulse'); }
  }, { passive: true });
})();

/* — Module 2: PDP title trim (" | Vyloire" suffix never shows on the H1) — */
(function () {
  var trim = function (el) {
    if (!el) return;
    var t = el.textContent;
    if (t && t.indexOf(' | ') > -1) { el.textContent = t.split(' | ')[0].trim(); }
  };
  var run = function () {
    document.querySelectorAll('.product__title h1, h1.product__title, .product__title > *:first-child').forEach(trim);
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();

/* — Module 3: PDP reveal motion — */
(function () {
  if (!document.querySelector('.product__info-container')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var desktop = window.matchMedia('(min-width: 750px)').matches;
  var els = [];
  document.querySelectorAll('.product__media-item').forEach(function (el, i) { if (!desktop && i > 0) return; el.classList.add('v-reveal'); el.style.setProperty('--v-order', Math.min(i, 3)); els.push(el); });
  var j = 0;
  document.querySelectorAll('.product__info-container > *').forEach(function (el) { var t = el.tagName; if (t === 'SCRIPT' || t === 'STYLE' || t === 'NOSCRIPT' || t === 'TEMPLATE' || t === 'LINK') return; el.classList.add('v-reveal'); el.style.setProperty('--v-order', Math.min(j, 6)); j++; els.push(el); });
  els.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 0.95 && r.bottom > 0) { el.classList.add('v-reveal--in'); } });
  if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('v-reveal--in'); }); return; }
  var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('v-reveal--in'); io.unobserve(e.target); } }); }, { rootMargin: '10000px 0px -8% 0px', threshold: 0.05 });
  els.forEach(function (el) { io.observe(el); });
})();

/* — Module 4: sticky buy bar + drop-down configurator — */
(function(){
var wrap=document.getElementById('v-satc-wrap');if(!wrap)return;
var panel=document.getElementById('v-satc-panel');
var submit=document.querySelector('.product-form__submit');if(!submit){wrap.remove();return;}
var priceEl=wrap.querySelector('[data-v-satc-price]');
var sumEl=wrap.querySelector('[data-v-satc-sum]');
var optBtn=wrap.querySelector('[data-v-satc-opt]');
var suppressClose=false;
function q(s){return document.querySelector(s);}
function fmtOpt(v){var m=/^(\d+)\s*[xX×]\s*(\d+)$/.exec(v);return m?m[1]+' × '+m[2]:v;}
function groups(){
var scope=q('.product__info-container variant-selects')||q('.product__info-container variant-radios')||q('.product__info-container');
return scope?scope.querySelectorAll('.product-form__input'):[];
}
function syncBar(){
var root=q('.product__info-container .price');
var onSale=root&&root.classList.contains('price--on-sale');
var p=onSale?q('.product__info-container .price__sale .price-item--sale'):q('.product__info-container .price__regular .price-item--regular');
if(!p){p=q('.product__info-container .price-item');}
if(p&&priceEl){priceEl.textContent=p.textContent.trim();}
var vals=[];groups().forEach(function(g){var c=g.querySelector('input[type=radio]:checked');if(c){vals.push(fmtOpt(c.value));}});
if(sumEl){sumEl.textContent=vals.length?vals.join(' · ')+' · ':'';}
}
var glideRaf=null;
function vGlide(toY){
if(glideRaf){cancelAnimationFrame(glideRaf);glideRaf=null;}
if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){window.scrollTo({top:toY,behavior:'instant'});return;}
var from=window.scrollY,d=toY-from;
if(Math.abs(d)<2)return;
var dur=Math.min(1200,400+Math.abs(d)*0.15),st=null;
function step(ts){
if(!st)st=ts;
var p=Math.min((ts-st)/dur,1);
var e=p<.5?4*p*p*p:1-Math.pow(-2*p+2,3)/2;
window.scrollTo({top:from+d*e,behavior:'instant'});
if(p<1){glideRaf=requestAnimationFrame(step);}else{glideRaf=null;}
}
glideRaf=requestAnimationFrame(step);
}
function setVariant(name,value){
var target=null;
groups().forEach(function(g){g.querySelectorAll('input[type=radio]').forEach(function(i){if(i.name===name&&i.value===value){target=i;}});});
suppressClose=true;
if(target&&!target.checked){
var sy=window.scrollY;
target.checked=true;
target.dispatchEvent(new Event('change',{bubbles:true}));
var tNow=function(){return (window.performance&&performance.now)?performance.now():Date.now();};
var pinUntil=tNow()+1200;
var pin=function(){
if(tNow()>pinUntil)return;
if(document.body.classList.contains('v-satc-active')){
var ae=document.activeElement;
if(ae&&ae.closest&&ae.closest('.product__info-container')){ae.blur();}
if(window.scrollY!==sy){window.scrollTo({top:sy,behavior:'instant'});}
}
requestAnimationFrame(pin);
};
requestAnimationFrame(pin);
}
setTimeout(function(){suppressClose=false;syncBar();if(!panel.hidden){buildPanel();}},500);
setTimeout(syncBar,1000);
}
function buildPanel(){
while(panel.firstChild){panel.removeChild(panel.firstChild);}
var inner=document.createElement('div');inner.className='v-cfg';
groups().forEach(function(g){
var leg=g.querySelector('legend, .form__label');
var radios=g.querySelectorAll('input[type=radio]');
if(!radios.length){return;}
var lab=document.createElement('p');lab.className='v-cfg-label';lab.textContent=leg?leg.textContent.trim():'Options';
var row=document.createElement('div');row.className='v-cfg-pills';
radios.forEach(function(i){
var b=document.createElement('button');b.type='button';b.textContent=fmtOpt(i.value);if(i.checked){b.className='v-sel';}
b.addEventListener('click',function(){setVariant(i.name,i.value);});
row.appendChild(b);
});
inner.appendChild(lab);inner.appendChild(row);
});
var sg=q('.product__info-container modal-opener button');
if(sg){var l=document.createElement('button');l.type='button';l.className='v-cfg-size-link';l.textContent='Size Guide';l.addEventListener('click',function(){closePanel();sg.click();});inner.appendChild(l);}
var act=document.createElement('div');act.className='v-cfg-actions';
var atc=document.createElement('button');atc.type='button';atc.className='v-cfg-atc';atc.textContent='Add to Cart';
atc.addEventListener('click',function(){var s=q('.product-form__submit');if(s){closePanel();s.click();}});
act.appendChild(atc);
if(q('.product__info-container .shopify-payment-button__button')){
var buy=document.createElement('button');buy.type='button';buy.className='v-cfg-buy';buy.textContent='Buy It Now';
buy.addEventListener('click',function(){var rb=q('.product__info-container .shopify-payment-button__button');if(rb){closePanel();rb.click();}});
act.appendChild(buy);
}
inner.appendChild(act);
panel.appendChild(inner);
}
function openPanel(){buildPanel();panel.hidden=false;optBtn.setAttribute('aria-expanded','true');}
function closePanel(){panel.hidden=true;optBtn.setAttribute('aria-expanded','false');}
optBtn.addEventListener('click',function(){if(panel.hidden){openPanel();}else{closePanel();}});
wrap.querySelector('[data-v-satc-btn]').addEventListener('click',function(){var s=q('.product-form__submit');if(s){s.click();}setTimeout(refreshCount,1500);});
var cartBtn=wrap.querySelector('[data-v-satc-cart]');
function refreshCount(){
fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
var el=wrap.querySelector('[data-v-satc-count]');if(!el)return;
if(c&&c.item_count>0){el.textContent=c.item_count>99?'99+':c.item_count;el.hidden=false;}else{el.hidden=true;}
}).catch(function(){});
}
if(cartBtn){
cartBtn.addEventListener('click',function(){
var d=document.querySelector('cart-drawer');
if(d&&typeof d.open==='function'){d.open(cartBtn);}
else{window.location.href=(window.routes&&window.routes.cart_url)?window.routes.cart_url:'/cart';}
});
}
function wireCartEvents(){
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){subscribe(PUB_SUB_EVENTS.cartUpdate,refreshCount);}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',wireCartEvents);}else{wireCartEvents();}
var revTarget=document.getElementById('vyloire-reviews');
var revBtn=wrap.querySelector('[data-v-nav=reviews]');
if(!revTarget&&revBtn){revBtn.remove();}
var artTarget=document.getElementById('v-artwork');
var artBtn=wrap.querySelector('[data-v-nav=artwork]');
if(!artTarget&&artBtn){artBtn.remove();}
wrap.querySelectorAll('[data-v-nav]').forEach(function(b){
b.addEventListener('click',function(){
var k=b.getAttribute('data-v-nav');
if(k==='top'){vGlide(0);}
else if(k==='artwork'){var t=document.getElementById('v-artwork');if(t){vGlide(window.scrollY+t.getBoundingClientRect().top-72);}}
else if(k==='reviews'){var r=document.getElementById('vyloire-reviews');if(r){vGlide(window.scrollY+r.getBoundingClientRect().top-72);}}
closePanel();
});
});
document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('variant-selects,variant-radios,.product-form__input')){setTimeout(syncBar,350);setTimeout(syncBar,900);}});
document.addEventListener('click',function(e){if(suppressClose)return;if(!panel.hidden&&!wrap.contains(e.target)){closePanel();}},true);
var ticking=false;
function evalBar(){
ticking=false;
var r=submit.getBoundingClientRect();
var visible=r.top<window.innerHeight*0.98&&r.bottom>4;
var on=!visible&&window.scrollY>120;
wrap.classList.toggle('v-on',on);
document.body.classList.toggle('v-satc-active',on);
if(!on){closePanel();}
}
function requestEval(){if(!ticking){ticking=true;requestAnimationFrame(evalBar);}}
window.addEventListener('scroll',requestEval,{passive:true});
window.addEventListener('resize',requestEval,{passive:true});
evalBar();
syncBar();
})();

/* — Module 5: cinematic mobile PDP gallery (one guided pass, user always wins) — */
(function(){
if(!window.matchMedia('(max-width: 749px)').matches)return;
if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var ul=document.querySelector('.product__media-list');if(!ul)return;
var items=Array.prototype.slice.call(ul.querySelectorAll('.product__media-item'));if(items.length<2)return;
ul.style.scrollSnapType='none';
var autoStopped=false,autoTimer=null,touching=false,gliding=false,raf=null,idleTimer=null,idx=0,maxAuto=Math.min(items.length,6);
function ease(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;}
function maxScroll(){return Math.max(0,ul.scrollWidth-ul.clientWidth);}
function targetFor(item){
var ur=ul.getBoundingClientRect(),ir=item.getBoundingClientRect();
var raw=ul.scrollLeft+(ir.left-ur.left)-((ul.clientWidth-ir.width)/2);
return Math.max(0,Math.min(raw,maxScroll()));
}
function nearest(){
var ur=ul.getBoundingClientRect(),cx=ur.left+ur.width/2,best=items[0],bd=Infinity;
for(var k=0;k<items.length;k++){
var ir=items[k].getBoundingClientRect();
var d=Math.abs((ir.left+ir.width/2)-cx);
if(d<bd){bd=d;best=items[k];}
}
return best;
}
function cancelGlide(){if(raf){cancelAnimationFrame(raf);raf=null;}gliding=false;}
function glide(to,dur){
cancelGlide();gliding=true;
var from=ul.scrollLeft,start=null;
if(Math.abs(to-from)<1){gliding=false;return;}
function step(ts){
if(!start)start=ts;
var p=Math.min((ts-start)/dur,1);
ul.scrollLeft=from+(to-from)*ease(p);
if(p<1){raf=requestAnimationFrame(step);}else{raf=null;gliding=false;}
}
raf=requestAnimationFrame(step);
}
function stopAuto(){autoStopped=true;if(autoTimer){clearInterval(autoTimer);autoTimer=null;}}
ul.addEventListener('touchstart',function(){touching=true;stopAuto();cancelGlide();},{passive:true});
ul.addEventListener('touchend',function(){touching=false;},{passive:true});
ul.addEventListener('touchcancel',function(){touching=false;},{passive:true});
['pointerdown','keydown','wheel'].forEach(function(ev){ul.addEventListener(ev,stopAuto,{passive:true});});
document.querySelectorAll('.slider-button').forEach(function(b){b.addEventListener('click',stopAuto,{passive:true});});
ul.addEventListener('scroll',function(){
if(gliding)return;
if(idleTimer)clearTimeout(idleTimer);
idleTimer=setTimeout(function(){
if(touching||gliding)return;
glide(targetFor(nearest()),900);
},110);
},{passive:true});
var visible=true;
if('IntersectionObserver' in window){new IntersectionObserver(function(en){visible=en[0].isIntersecting;},{threshold:.4}).observe(ul);}
autoTimer=setInterval(function(){
if(autoStopped||gliding||touching)return;
if(document.hidden||!visible)return;
idx++;
if(idx>=maxAuto){stopAuto();return;}
glide(targetFor(items[idx]),1400);
},5600);
})();
